import * as Sentry from "@sentry/react";
import { setMonitoringAdapter } from "@template/shared";

/**
 * Initialise Sentry-compatible error monitoring for the web app.
 *
 * Backend-agnostic: point VITE_SENTRY_DSN at Sentry SaaS, a self-hosted
 * Sentry, or GlitchTip. Template stays portable — adopters wire their
 * chosen backend by setting the env var at build time.
 *
 * No-op when VITE_SENTRY_DSN is unset, so local dev stays zero-config
 * and the feature can be enabled per-environment via Vite env vars.
 */
const dsn = import.meta.env.VITE_SENTRY_DSN;

const environment = import.meta.env.VITE_SENTRY_ENVIRONMENT;
const mode = import.meta.env.MODE;

if (typeof dsn === "string" && dsn.length > 0) {
  Sentry.init({
    dsn,
    environment:
      typeof environment === "string" ? environment : typeof mode === "string" ? mode : undefined,
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
  });

  setMonitoringAdapter((error, context) => {
    Sentry.captureException(error, context ? { extra: context } : undefined);
  });
}
